<template>
  <div
    id="list"
    class="w1100"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="处理中…… 请耐心等待"
    element-loading-spinner="el-icon-loading"
  >
    <div
      style="
        background-color: #fbfbfb;
        width: 1100px;
        height: auto;
        margin-top: 36px;
        padding: 24px 12px;
      "
    >
      <div style="color: #c8c8c8; margin-bottom: 24px">
        当前位置：首页 > 中心动态
      </div>
      <div style="width: 100%; display: flex; flex-wrap: wrap">
        <div
          v-for="(item, index) in datas"
          :key="index"
          style="
            cursor: pointer;
            width: 48%;
            margin: 0% 1%;
            margin-bottom: 8px;
            height: 400px;
          "
        >
          <div
            style="
              border-bottom: 1px solid #e7e7e7;
              overflow: hidden;
              height: 30px;
              margin-bottom: 16px;
            "
          >
            <span style="font-size: 16px; font-weight: 700; float: left">{{
              item.menuInfoName2
            }}</span>
            <span
              style="
                font-size: 14px;
                font-weight: 700;
                color: #135338;
                float: right;
              "
              @click="goMore(item)"
              >更多+</span
            >
          </div>
          <div
            v-for="(val, i) in item.data"
            :key="i"
            style="
              border: 1px solid #e7e7e7;
              padding: 12px;
              margin-bottom: 24px;
              display: flex;
              height: 134px;
            "
            @click="toDetail(val.id,val.title)"
          >
            <img
              v-if="val.picUrl"
              @error="handleImageError"
              :src="
                val.picUrl ? '/mainsys/UserFiles/menupic/' + val.picUrl : ''
              "
              style="width: 35%; height: 110px"
            />
            <div
              style="
                width: 1px;
                height: 110px;
                background-color: #e7e7e7;
                margin: 0px 8px;
              "
            ></div>
            <div
              style="
                width: calc(64% - 16px);
                padding: 4px 0px;
                position: relative;
              "
            >
              <div
                style="
                  width: 100%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  margin-bottom: 8px;
                "
              >
                {{ val.title }}
              </div>
              <div
                style="
                  width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  color: #c8c8c8;
                  font-size: 14px;
                  margin-top: 8px;
                "
              >
                {{ val.descripton }}
              </div>
              <div style="position: absolute; bottom: 0">
                {{ val?.addDate.substring(0, 10) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      fullscreenLoading: false,
      menuId: this.$route.params.menuId,
      contentList: [],
      datas: [],
    };
  },
  methods: {
    handleImageError(e){
      e.target.src = require('../assets/2.png')
    },
    goMore(item) {
      this.$router.push({
        path: "List:menuId",
        name: "List",
        params: { menuId: item.menuInfoName2Id, label: item.menuInfoName2 },
      });
    },
    toList(menuId, label) {
      this.$router.push({
        path: "List:menuId",
        name: "List",
        params: { menuId: menuId, label: label },
      });
    },
    getSecondList() {
      this.fullscreenLoading = true;
      let fd = new FormData();
      fd.append("menuId", this.menuId);
      fd.append("num", 2);
      var choosedItem = {};
      axios
        .post("/cmsapi/getMenus2", fd, {
          //顶部友情链接
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then((response) => {
          this.datas = response.data;
          this.fullscreenLoading = false;
        })
        .catch((error) => {
          this.fullscreenLoading = false;
        });
    },
    toDetail(contentId, label) {
      this.$router.push({
        path: "detail:contentId",
        name: "Detail",
        params: { contentId: contentId, label: label },
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.params.menuId) {
        this.menuId = this.$route.params.menuId;
        this.getSecondList();
      }
    });
  },
  beforeEacch(to, from, next) {
    if (this.$route.params.menuId) {
      this.menuId = this.$route.params.menuId;
      this.getSecondList();
    }
    next();
  },
  beforeRouteUpdate(to, from, next) {
    next();
    // if (this.$route.params.menuId) {
    this.menuId = this.$route.params.menuId;
    this.getSecondList();
    // }
  },
};
</script>
